import React from 'react'
import { BasePage as CngBasePage } from 'cng-web-lib'
import { ScopedCssBaseline } from '@mui/material'
import { SnackbarProvider } from 'src/contexts/era-package/SnackbarContext'
import { ToolsView } from './ToolsView'
import useBreadcrumbNameMap from 'src/useBreadcrumbNameMap'

export const ToolsPage = () => {
  const breadcrumbNameMap = useBreadcrumbNameMap()
  return <CngBasePage
    renderPage={(showSnackbar) => (
      <ScopedCssBaseline>
        <SnackbarProvider>
          <ToolsView />
        </SnackbarProvider>
      </ScopedCssBaseline>)}
    extraCngBreadcrumbNameMap={breadcrumbNameMap}
  />
}
